export const term = {
    labels: {
        term: "Term",
        terms: "Terms",
        add_term: "Add Term",
        delete_term: "Delete Term",
    },
    placeholders: {
    },
    modals: {
        titles: {
            term_remove: "Remove Term",
        },
        messages: {
            term_remove: "Do you really want to remove the term <strong>{name}</strong>?<br/>This action cannot be undone.",
        }
    },
    texts: {
        empty: "There are no terms to display",
        add_term: "Would you like to add a term for this item?",
        delete_term: "Do you want to delete this term?<br/>This action cannot be undone.",
    },
};
